import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    // redirect: '/home',
    redirect: '/finance',
    component:  () => import('@/views/Index.vue'),
    children: [
      // // 工作台
      // {
      //   path: '/home',
      //   name: 'Home',
      //   component: () => import('@/views/Home/index.vue')
      // },
      // // 审核名片
      // {
      //   path: '/waitExamine',
      //   name: 'WaitExamine',
      //   component: () => import('@/views/WaitExamine/index.vue')
      // },
      // // 合伙人申请
      // {
      //   path: '/copartner',
      //   name: 'Copartner',
      //   component: () => import('@/views/Copartner/index.vue')
      // },
      // {
      //   path: '/updateCopartner',
      //   name: 'UpdateCopartner',
      //   component: () => import('@/views/Copartner/update.vue')
      // },
      // 名片管理
      {
        path: '/personal',
        name: 'Personal',
        component: () => import('@/views/Personal/index.vue')
      },
      {
        path: '/addPersonal',
        name: 'AddPrsonal',
        component: () => import('@/views/Personal/add.vue')
      },
      {
        path: '/updatePersonal',
        name: 'UpdatePrsonal',
        component: () => import('@/views/Personal/update.vue')
      },
      // 矩阵名片cards
      {
        path: '/cards',
        name: 'Cards',
        component: () => import('@/views/Cards/index.vue')
      },
      // 矩阵名片cards2
      {
        path: '/cards2',
        name: 'Cards2',
        component: () => import('@/views/Cards2/add.vue')
      },
      // 企业管理
      {
        path: '/information',
        name: 'Information',
        component: () => import('@/views/Information/index.vue')
      },
      {
        path: '/addInformation',
        name: 'AddInformation',
        component: () => import('@/views/Information/add.vue')
      },
      {
        path: '/updateInformation',
        name: 'UpdateInformation',
        component: () => import('@/views/Information/update.vue')
      },
      // 合伙人管理
      {
        path: '/agent',
        name: 'Agent',
        component: () => import('@/views/Agent/index.vue')
      },
      // 代理商管理
      {
        path: '/proxy',
        name: 'Proxy',
        component: () => import('@/views/Proxy/index.vue')
      },
      // 代理商业绩管理
      {
        path: '/proxySales',
        name: 'ProxySales',
        component: () => import('@/views/Proxy/sales.vue')
      },
      // // 电子画册
      // {
      //   path: '/ebook',
      //   name: 'Ebook',
      //   component: () => import('@/views/Ebook/index.vue')
      // },
      // {
      //   path: '/addEbook',
      //   name: 'AddEbook',
      //   component: () => import('@/views/Ebook/add.vue')
      // },
      // {
      //   path: '/updateEbook',
      //   name: 'UpdateEbook',
      //   component: () => import('@/views/Ebook/update.vue')
      // },
      // // 产品分类
      // {
      //   path: '/classify',
      //   name: 'Classify',
      //   component: () => import('@/views/Classify/index.vue')
      // },
      // {
      //   path: '/addClassify',
      //   name: 'AddClassify',
      //   component: () => import('@/views/Classify/add.vue')
      // },
      // {
      //   path: '/updateClassify',
      //   name: 'UpdateClassify',
      //   component: () => import('@/views/Classify/update.vue')
      // },
      // // 产品中心
      // {
      //   path: '/product',
      //   name: 'Product',
      //   component: () => import('@/views/Product/index.vue')
      // },
      // {
      //   path: '/addProduct',
      //   name: 'AddProduct',
      //   component: () => import('@/views/Product/add.vue')
      // },
      // {
      //   path: '/updateProduct',
      //   name: 'UpdateProduct',
      //   component: () => import('@/views/Product/update.vue')
      // },
      // // 订单管理
      // {
      //   path: '/order',
      //   name: 'Order',
      //   component: () => import('@/views/Order/index.vue')
      // },
      // {
      //   path: '/updateOrder',
      //   name: 'UpdateOrder',
      //   component: () => import('@/views/Order/update.vue')
      // },
      // 财务管理
      {
        path: '/finance',
        name: 'Finance',
        component: () => import('@/views/Finance/index.vue')
      },
      {
        path: '/addFinance',
        name: 'AddFinance',
        component: () => import('@/views/Finance/add.vue')
      },
      {
        path: '/updateFinance',
        name: 'UpdateFinance',
        component: () => import('@/views/Finance/update.vue')
      },
      // 提现管理
      {
        path: '/cash',
        name: 'Cash',
        component: () => import('@/views/Cash/index.vue')
      },
      {
        path: '/updateCash',
        name: 'UpdateCash',
        component: () => import('@/views/Cash/update.vue')
      },
      // // 浏览记录
      // {
      //   path: '/viewCard',
      //   name: 'ViewCard',
      //   component: () => import('@/views/ViewCard/index.vue')
      // },
      // {
      //   path: '/userCenter',
      //   name: 'UserCenter',
      //   component: () => import('@/views/System/UserCenter.vue')
      // },
      // // 修改密码
      // {
      //   path: '/updatePwd',
      //   name: 'UpdatePwd',
      //   component: () => import('@/views/System/UpdatePwd.vue')
      // },
      // // 系统账号管理
      // {
      //   path: '/sonAccount',
      //   name: 'SonAccount',
      //   component: () => import('@/views/System/SonAccount.vue')
      // },
      // {
      //   path: '/addSonAccount',
      //   name: 'AddSonAccount',
      //   component: () => import('@/views/System/AddSonAccount.vue')
      // },
      // {
      //   path: '/updateSonAccount',
      //   name: 'UpdateSonAccount',
      //   component: () => import('@/views/System/UpdateSonAccount.vue')
      // },
      // // 企业账号管理
      // {
      //   path: '/companyAccount',
      //   name: 'CompanyAccount',
      //   component: () => import('@/views/CompanyAccount/index.vue')
      // },
      // {
      //   path: '/addCompanyAccount',
      //   name: 'AddCompanyAccount',
      //   component: () => import('@/views/CompanyAccount/add.vue')
      // },
      // {
      //   path: '/updateCompanyAccount',
      //   name: 'UpdateCompanyAccount',
      //   component: () => import('@/views/CompanyAccount/update.vue')
      // },
      // // 个人账号管理
      // {
      //   path: '/personalAccount',
      //   name: 'PersonalAccount',
      //   component: () => import('@/views/PersonalAccount/index.vue')
      // },
      // {
      //   path: '/addPersonalAccount',
      //   name: 'AddPersonalAccount',
      //   component: () => import('@/views/PersonalAccount/add.vue')
      // },
      // {
      //   path: '/updatePersonalAccount',
      //   name: 'UpdatePersonalAccount',
      //   component: () => import('@/views/PersonalAccount/update.vue')
      // }


      // {
      //   path: '/store',
      //   name: 'Store',
      //   component: () => import('@/views/Store/index.vue')
      // },
      // {
      //   path: '/addStore',
      //   name: 'AddStore',
      //   component: () => import('@/views/Store/add.vue')
      // },
      // {
      //   path: '/updateStore',
      //   name: 'UpdateStore',
      //   component: () => import('@/views/Store/update.vue')
      // },
      // {
      //   path: '/employee',
      //   name: 'Employee',
      //   component: () => import('@/views/Employee/index.vue')
      // },
      // {
      //   path: '/addEmployee',
      //   name: 'AddEmployee',
      //   component: () => import('@/views/Employee/add.vue')
      // },
      // {
      //   path: '/updateEmployee',
      //   name: 'UpdateEmployee',
      //   component: () => import('@/views/Employee/update.vue')
      // },
      // {
      //   path: '/setStore',
      //   name: 'SetStore',
      //   component: () => import('@/views/Employee/setStore.vue')
      // },
      // {
      //   path: '/activity/examine',
      //   name: 'ActivityExamine',
      //   component: () => import('@/views/Activity/examine.vue')
      // },
      // {
      //   path: '/activity',
      //   name: 'Activity',
      //   component: () => import('@/views/Activity/index.vue')
      // },
      // {
      //   path: '/preactivity/examine',
      //   name: 'PreactivityExamine',
      //   component: () => import('@/views/Preactivity/examine.vue')
      // },
      // {
      //   path: '/preactivity',
      //   name: 'Preactivity',
      //   component: () => import('@/views/Preactivity/index.vue')
      // },
      // {
      //   path: '/report/examine',
      //   name: 'ReportExamine',
      //   component: () => import('@/views/Report/examine.vue')
      // },
      // {
      //   path: '/report',
      //   name: 'Report',
      //   component: () => import('@/views/Report/index.vue')
      // },
      // {
      //   path: '/userCenter',
      //   name: 'UserCenter',
      //   component: () => import('@/views/System/UserCenter.vue')
      // },
      // {
      //   path: '/updatePwd',
      //   name: 'UpdatePwd',
      //   component: () => import('@/views/System/UpdatePwd.vue')
      // },
      // {
      //   path: '/sonAccount',
      //   name: 'SonAccount',
      //   component: () => import('@/views/System/SonAccount.vue')
      // },
      // {
      //   path: '/addSonAccount',
      //   name: 'AddSonAccount',
      //   component: () => import('@/views/System/AddSonAccount.vue')
      // },
      // {
      //   path: '/updateSonAccount',
      //   name: 'UpdateSonAccount',
      //   component: () => import('@/views/System/UpdateSonAccount.vue')
      // },
      // {
      //   path: '/exportActivity',
      //   name: 'ExportActivity',
      //   component: () => import('@/views/ExportActivity/index.vue')
      // },
      // {
      //   path: '/exportActivity/examine',
      //   name: 'ExportActivityExamine',
      //   component: () => import('@/views/ExportActivity/examine.vue')
      // },

      // {
      //   path: '/demo',
      //   name: 'Demo',
      //   component: () => import('@/views/demo.vue')
      // }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login/index.vue')
  },
  {
    path: '/print',
    name: 'Print',
    component: () => import('@/views/table-print.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
